export default __webpack_public_path__ + "static/media/Mobile-Agromart.4f91d1a7.png";